import * as React from 'react';
import {useStyles} from "./styles";
import {useDispatch} from "react-redux";
import {useState} from "react";
import {Button, CircularProgress} from "@mui/material";
import {getS3Url} from "../../../api";
import {Notifications} from "../../../store/slices";
import imageCompression from "browser-image-compression";
import {Delete, Add} from '@mui/icons-material';

export default function StoryImages(props: any) {
    const {onChange, value = [], name = 'storyImages', label = 'Story Images'} = props
    const [isPopUp, setPopUp] = useState(false)
    const [image, setImage] = useState<any| null>()
    const [pending, setPending] = useState(false);
    const classes = useStyles();
    const dispatch = useDispatch();

    const currentImages = Array.isArray(value) ? value : [];

    async function inputImageHandler (event: any) {
        setPending(true);
        const imageFile = event.target.files[0];
        if (!imageFile) {
            setPending(false);
            return false;
        }

        const options = {
            maxSizeMB: 0.5,
            maxWidthOrHeight: 1940,
            useWebWorker: true,
        }
        try {
            const compressedFile = await imageCompression(imageFile, options);
            await setImage(compressedFile); 
            setPending(false);
        } catch (error) {
            console.log(error);
            setPending(false);
        }
    }

    function handleUpload() {
        if (!image) {
            return;
        }

        const reader = new FileReader();
        reader.readAsArrayBuffer(image);

        reader.onload = function() {
            if (reader.result !== null) {
                // @ts-ignore
                const blob = new Blob([reader.result], { type: image.type });
                uploadImage(blob);
            }
        };
    }

    const uploadImage = async (blob: any) => {
        setPending(true);
        try {
            await getS3Url({
                blob,
                onSuccess: (result: any) => {
                    const newImages = [...currentImages, result.url];
                    onChange({target:{name: name, value: newImages}})
                    dispatch(Notifications.setNotifications({text: 'Image uploaded, don\'t forget save changes!', type: 'warning'}))
                    setPending(false);
                    popUpHandler(true); // reset image
                }
            });
        } catch (error) {
            dispatch(Notifications.setNotifications({text: 'Something went wrong, please try again later', type: 'error'}))
            setPending(false);
        }
    };

    const removeImage = (index: number) => {
        const newImages = currentImages.filter((_: any, i: number) => i !== index);
        onChange({target:{name: name, value: newImages}});
    }

    const popUpHandler = (cancel?: boolean) =>{
        if (cancel) {
             setImage(null);
        }
        setPopUp(prevState => !prevState)
    }

    return (
        <div className={classes.blockWrap}>
            <div className={classes.blockLabel}>{label}</div>
            <div className={classes.imagesContainer}>
                {currentImages.map((img: string, index: number) => (
                    <div key={index} className={classes.imageWrap}>
                        <img src={img} alt={`Story ${index}`} />
                        <div className={classes.deleteButton} onClick={() => removeImage(index)}>
                            <Delete fontSize="small" />
                        </div>
                    </div>
                ))}
                <div className={classes.addButton} onClick={() => popUpHandler()}>
                    <Add fontSize="large" />
                </div>
            </div>

            {isPopUp &&
                <div className={classes.popUpWrapper}>
                    <div className={classes.popUp}>
                        {pending && <div className={classes.popUpLoader}><CircularProgress size={80} /></div>}
                        <div className={classes.popUpImage}>
                            {image ? <img src={URL.createObjectURL(image)}/> : <div style={{height: 200, display:'flex', justifyContent:'center', alignItems:'center'}}>Select an image</div>}
                        </div>
                        <div className={classes.buttonsWrap}>
                            <Button
                                variant="outlined"
                                onClick={()=>popUpHandler(true)}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                color="secondary"
                                component="label"
                            >
                                Chose image
                                <input
                                    accept="image/*"
                                    name="image"
                                    type="file"
                                    onChange={inputImageHandler}
                                    hidden
                                />
                            </Button>
                            {image &&
                                <Button
                                variant="contained"
                                onClick={handleUpload}
                            >
                                Upload
                            </Button>
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}
